module.exports = __webpack_public_path__ + "static/media/editorial-logos-bw_small.70fde3dc.png";